import type { SVGProps } from "react";
export const ShoppingCart = (props: SVGProps<SVGSVGElement>) => (
	<svg
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		aria-hidden={true}
		{...props}
	>
		<path
			d="M5.9145 21.047C5.57417 20.7067 5.404 20.2936 5.404 19.8078C5.404 19.3218 5.57417 18.9086 5.9145 18.5683C6.25483 18.2279 6.66792 18.0577 7.15375 18.0577C7.63975 18.0577 8.05292 18.2279 8.39325 18.5683C8.73358 18.9086 8.90375 19.3218 8.90375 19.8078C8.90375 20.2936 8.73358 20.7067 8.39325 21.047C8.05292 21.3875 7.63975 21.5578 7.15375 21.5578C6.66792 21.5578 6.25483 21.3875 5.9145 21.047ZM15.6068 21.047C15.2664 20.7067 15.0962 20.2936 15.0962 19.8078C15.0962 19.3218 15.2664 18.9086 15.6068 18.5683C15.9471 18.2279 16.3602 18.0577 16.8462 18.0577C17.3321 18.0577 17.7452 18.2279 18.0855 18.5683C18.4258 18.9086 18.596 19.3218 18.596 19.8078C18.596 20.2936 18.4258 20.7067 18.0855 21.047C17.7452 21.3875 17.3321 21.5578 16.8462 21.5578C16.3602 21.5578 15.9471 21.3875 15.6068 21.047ZM6.01525 5.75L8.55 11.0577H15.55L18.4635 5.75H6.01525ZM5.29625 4.25H21.0077L16.4365 12.5577H8.1L6.73075 15.0577H18.596V16.5577H4.18275L7.04225 11.4078L3.404 3.75H1.5V2.25H4.34625L5.29625 4.25Z"
			fill="currentColor"
		/>
	</svg>
);
